var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.207,
    height: 29.207,
    viewBox: "0 0 29.207 29.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_9557",
    "data-name": "\\uADF8\\uB8F9 9557",
    transform: "translate(-47.617 -382.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7206",
    "data-name": "\\uD328\\uC2A4 7206",
    d: "M-301.994,281.318h-12.581a8.322,8.322,0,0,1-8.313-8.313V260.424a8.322,8.322,0,0,1,8.313-8.313h12.581a8.322,8.322,0,0,1,8.313,8.313v12.581A8.322,8.322,0,0,1-301.994,281.318Zm-12.581-26.7a5.816,5.816,0,0,0-5.809,5.809v12.581a5.816,5.816,0,0,0,5.809,5.809h12.581a5.816,5.816,0,0,0,5.809-5.809V260.424a5.816,5.816,0,0,0-5.809-5.809Z",
    transform: "translate(370.505 130.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7207",
    "data-name": "\\uD328\\uC2A4 7207",
    d: "M-276.9,305.576a7.487,7.487,0,0,1-7.478-7.478,7.487,7.487,0,0,1,7.478-7.478,7.487,7.487,0,0,1,7.478,7.478A7.487,7.487,0,0,1-276.9,305.576Zm0-12.453a4.981,4.981,0,0,0-4.975,4.975,4.981,4.981,0,0,0,4.975,4.975,4.981,4.981,0,0,0,4.975-4.975A4.981,4.981,0,0,0-276.9,293.122Z",
    transform: "translate(339.122 98.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7208",
    "data-name": "\\uD328\\uC2A4 7208",
    d: "M-207.932,280.39a1.8,1.8,0,0,1-1.8,1.8,1.8,1.8,0,0,1-1.8-1.8,1.8,1.8,0,0,1,1.8-1.8A1.8,1.8,0,0,1-207.932,280.39Z",
    transform: "translate(279.75 108.625)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.78a2c002870fe6effeb0118a2e3b7f8a.svg";
export { ForwardRef as ReactComponent };